<app-count-box
  icon="fa-regular fa-map"
  [styleClass]="styleClass"
  [text]="text"
  mode="view"
  [label]="title"
  [count]="store.count()"
  severity="secondary" />
